import { observable } from "mobx";

export interface Combination {
  areaId: string;
}

export default class FaultyCombination {
  @observable faultyCombinations: Combination[] = [];
}
